module.exports = __webpack_public_path__ + "img/circle4yellow.b498f066.png";